import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { ShieldCheck, LockKey, Feather } from "@phosphor-icons/react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/admin/me").then(() => navigate("/admin", { replace: true })).catch(() => {});
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/admin/login", { email: email.trim(), password });
      navigate("/admin", { replace: true });
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen paper-grain flex flex-col" data-testid="admin-login-page">
      <nav className="border-b border-border">
        <div className="max-w-6xl mx-auto flex items-center justify-between px-6 py-4">
          <div className="flex items-center gap-2">
            <Feather size={22} weight="duotone" className="text-primary" />
            <span className="font-serif text-2xl tracking-tight">Antic</span>
            <span className="text-xs uppercase tracking-[0.3em] text-muted-foreground ml-3 border-l border-border pl-3">
              Admin
            </span>
          </div>
        </div>
      </nav>

      <main className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md">
          <div className="mb-10 text-center">
            <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-primary/10 text-primary mb-6">
              <ShieldCheck size={28} weight="duotone" />
            </div>
            <p className="text-xs uppercase tracking-[0.3em] text-muted-foreground">Restricted</p>
            <h1 className="font-serif text-5xl font-light tracking-tighter mt-3">
              Admin <span className="italic text-accent">console</span>
            </h1>
          </div>

          <form onSubmit={submit} className="bg-card border border-border rounded-lg p-6 space-y-4">
            <div>
              <label className="text-xs uppercase tracking-[0.2em] text-muted-foreground block mb-2">
                Email
              </label>
              <Input
                data-testid="admin-email-input"
                type="email"
                autoComplete="username"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="bg-transparent"
              />
            </div>
            <div>
              <label className="text-xs uppercase tracking-[0.2em] text-muted-foreground block mb-2">
                Password
              </label>
              <Input
                data-testid="admin-password-input"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="bg-transparent"
              />
            </div>
            <Button
              data-testid="admin-login-btn"
              type="submit"
              disabled={busy}
              className="w-full rounded-full bg-primary text-primary-foreground hover:bg-primary/90 h-11"
            >
              <LockKey size={16} className="mr-2" />
              {busy ? "Signing in…" : "Sign in"}
            </Button>
          </form>

          <p className="text-xs text-muted-foreground mt-6 text-center">
            5 wrong attempts locks the account for 15 minutes.
          </p>
        </div>
      </main>
    </div>
  );
}
